import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { IncrementalsService } from 'app/siq-applications/modules/incrementals/services/incrementals.service';

@Injectable()
export class IncrementalsCloneResolverService implements Resolve<void> {

  constructor(private incrementalsService: IncrementalsService) { }

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<void> | Promise<void> | void {
    this.incrementalsService.cloneReport(route.paramMap.get('id'));
  }
}
